import { TagDefinition } from '../../models/tagDefinition';

export const getTagMarker = (tag: TagDefinition) => {
    return {
        lat: parseFloat(tag.customProperties['latitude']),
        lng: parseFloat(tag.customProperties['longitude']),
        message: tag.longComment,
        draggable: false,
        guid: tag.guid,
        objectType: 'Tag'
    };
};
